<div class="hvac-check-list">
    <h4 class="hvac-check-list-name">
        <utc-svg class="hvac-check-list-icon" src="assets/icons/circle-check.svg"></utc-svg>
        <span [innerHTML]="item?.Content?.title | richText"></span>
    </h4>
    <div class="hvac-check-list-item-bullets" [innerHtml]="item?.Content?.text | richText"></div>
</div>

